(function () {
  'use strict';

  angular.module('app').component('teamMemberPage', teamMemberDetailComponent());

  function teamMemberDetailComponent() {
    return {
      bindings: {},
      controller: TeamMemberDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/team-members/team-member-page.component.html',
    };
  }

  TeamMemberDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'TeamMemberService',
  ];

  function TeamMemberDetailCtrl($location, $routeParams, AbilityService, TeamMemberService) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_teammember_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        TeamMemberService.getTeamMember(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/team_members/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/team_members');
    }
  }
})();
